import { gql, useQuery } from "@apollo/client";
import { Card, CircularProgress, Grid, Icon } from "@mui/material";
import logo from "assets/images/logo.png";
import PageLayout from "components/LayoutContainers/PageLayout";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import firmaGuia from "assets/images/firmaGuia.png";
import SoftButton from "components/SoftButton";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const meses = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];
function ControlGuia() {
  const { url } = useParams();

  const { data, loading, error } = useQuery(
    gql`
      query getGuiaByUrl($url: String!) {
        guiaByUrl(url: $url) {
          id
          nroGuia
          originariosDe
          destino
          domicilioDestino
          medioTransporte
          fechaExpedicion
          estado
          url
          detalles {
            cantidad
            especie
            descripcion
          }
          comentario
          anioGuia
          tiempoValidez
          usuario {
            nombre
            apellido
            dni
            id
          }
        }
      }
    `,
    {
      variables: { url },
    }
  );

  const generatePDF = () => {
    const element = document.getElementById("certificado");
    const originalWidth = element.style.width;
    const originalHeight = element.style.height;

    element.style.width = "794px"; // Ancho en píxeles para A4
    element.style.height = "1123px"; // Alto en píxeles para A4
    element.style.overflow = "visible"; // Evita recortes
    setTimeout(() => {
      if (element) {
        html2canvas(element, { scale: 1 }).then((canvas) => {
          const imgData = canvas.toDataURL("image/jpeg", 1);

          const report = new jsPDF({
            orientation: "portrait",
            compress: true,
          });

          const pdfWidth = report.internal.pageSize.getWidth();
          const pdfHeight = report.internal.pageSize.getHeight();

          report.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
          report.save(
            `Guía de tránsito${data?.guiaByUrl?.anioGuia}-${data?.guiaByUrl?.nroGuia}.pdf`
          );
          element.style.width = originalWidth;
          element.style.height = originalHeight;
        });
      }
    }, 500);
  };
  return (
    <PageLayout>
      <SoftBox sx={{ position: "fixed", right: "30px", bottom: "30px", zIndex: 9999 }}>
        <SoftButton onClick={generatePDF} color="primary" sx={{ margin: "0 10px" }}>
          DESCARGAR PDF
        </SoftButton>
      </SoftBox>
      <SoftBox display="flex" justifyContent="center" alignItems="center" p={3}>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12} md={10}>
            <Card>
              {loading ? (
                <SoftBox p={2}>
                  <SoftBox display="flex" justifyContent="center" alignItems="center">
                    <SoftBox
                      component="img"
                      src={logo}
                      alt="Gobierno de San Luis Logo"
                      width="100px"
                      p={3}
                    />
                  </SoftBox>
                  <SoftBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    p={2}
                    textAlign="center"
                  >
                    <SoftTypography variant="h6">Buscando permiso</SoftTypography>
                  </SoftBox>
                  <SoftBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                    p={2}
                  >
                    <CircularProgress size={30} color="primary" />
                  </SoftBox>
                </SoftBox>
              ) : data?.guiaByUrl ? (
                <SoftBox id="certificado" p={3}>
                  <SoftBox>
                    <Grid container>
                      <Grid item xs={6} pb={1}>
                        <SoftTypography variant="h6">Dirección de biodiversidad</SoftTypography>
                        <SoftTypography variant="h6">Área fauna</SoftTypography>
                      </Grid>
                      <Grid item xs={6} display="flex" justifyContent="flex-end" pb={1}>
                        <SoftBox
                          component="img"
                          src={logo}
                          alt="Gobierno de la Provincia de San Luis Logo"
                          width="200px"
                        ></SoftBox>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        textAlign="center"
                        sx={{
                          lineHeight: 1,
                        }}
                        pb={1}
                      >
                        <SoftTypography variant="caption" fontWeight="bold">
                          Casa de Gobierno Ecológico &quot;Terrazas del Portezuelo&quot; <br />
                        </SoftTypography>
                        <SoftTypography variant="caption">
                          Edificio Capital - Bloque 2 - 2° Piso. Autopista Serranías Puntana Km 783
                          (5700) San Luis <br />
                        </SoftTypography>
                        <SoftTypography variant="caption">
                          e-mail: ccsilvestre@gmail.com / me.pmedioambiente@gmail.com <br />
                        </SoftTypography>
                        <SoftTypography variant="caption">
                          Tel: (+54) 2664452000 - Int. 3372
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={6} pb={1}>
                        <SoftTypography variant="h5" textAlign="center">
                          Guía de Tránsito
                        </SoftTypography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        pb={1}
                        display="flex"
                        justifyContent="flex-end"
                        alignItems="flex-end"
                      >
                        <SoftTypography variant="caption" textAlign="end">
                          {`Original Nº C-${data?.guiaByUrl?.nroGuia}-${data?.guiaByUrl?.anioGuia}`}
                        </SoftTypography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        pb={1}
                        sx={{
                          lineHeight: 1,
                        }}
                      >
                        <SoftTypography variant="caption">
                          La autoridad que suscribe por medio de la presente autoriza a{" "}
                          <strong>{`${data?.guiaByUrl?.usuario?.apellido}, ${data?.guiaByUrl?.usuario?.nombre} DNI N°${data?.guiaByUrl?.usuario?.dni}`}</strong>
                          , a transportar fuera de los límites de esta provincia, los productos de
                          la fauna silvestre que a continuación se detallan.
                        </SoftTypography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={12}
                        sx={{
                          border: "1px solid black",
                        }}
                      >
                        <Grid
                          item
                          xs={3}
                          textAlign="center"
                          sx={{
                            borderRight: "1px solid black",
                            borderBottom: "1px solid black",
                          }}
                        >
                          <SoftTypography variant="subtitle2">Cantidad</SoftTypography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          textAlign="center"
                          sx={{
                            borderRight: "1px solid black",
                            borderBottom: "1px solid black",
                          }}
                        >
                          <SoftTypography variant="subtitle2">Especie</SoftTypography>
                        </Grid>
                        <Grid
                          item
                          xs={5}
                          textAlign="center"
                          sx={{
                            borderBottom: "1px solid black",
                          }}
                        >
                          <SoftTypography variant="subtitle2">Descripción</SoftTypography>
                        </Grid>
                        {data?.guiaByUrl?.detalles?.map((item, index) => (
                          <Grid container item xs={12} key={index}>
                            <Grid
                              item
                              xs={3}
                              textAlign="center"
                              sx={{
                                borderRight: "1px solid black",
                                borderBottom:
                                  index === data?.guiaByUrl?.detalles?.length - 1
                                    ? "none"
                                    : "1px solid black",
                                lineHeight: 1,
                              }}
                            >
                              <SoftTypography variant="caption">{item?.cantidad}</SoftTypography>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              textAlign="center"
                              sx={{
                                borderRight: "1px solid black",
                                borderBottom:
                                  index === data?.guiaByUrl?.detalles?.length - 1
                                    ? "none"
                                    : "1px solid black",
                                lineHeight: 1,
                              }}
                            >
                              <SoftTypography variant="caption">{item?.especie}</SoftTypography>
                            </Grid>
                            <Grid
                              item
                              xs={5}
                              textAlign="center"
                              sx={{
                                borderBottom: "1px solid black",
                                borderBottom:
                                  index === data?.guiaByUrl?.detalles?.length - 1
                                    ? "none"
                                    : "1px solid black",
                                lineHeight: 1,
                              }}
                            >
                              <SoftTypography variant="caption">{item?.descripcion}</SoftTypography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        py={1}
                        sx={{
                          lineHeight: 1,
                        }}
                      >
                        <SoftTypography variant="caption">
                          Originarios de <strong>{data?.guiaByUrl?.originariosDe}</strong> con
                          destino a la firma o persona jurídica
                          <strong> {data?.guiaByUrl?.destino}</strong> con domicilio en{" "}
                          <strong>{data?.guiaByUrl?.domicilioDestino}</strong>. <br />
                          Medio de transporte: <strong>{data?.guiaByUrl?.medioTransporte}</strong>.
                        </SoftTypography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sx={{
                          lineHeight: 1,
                          border: "1px solid black",
                        }}
                      >
                        <SoftTypography variant="caption">
                          Válido por <strong>{data?.guiaByUrl?.tiempoValidez} horas</strong> a
                          partir de la fecha de expedición.
                        </SoftTypography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        pb={1}
                        sx={{
                          lineHeight: 1,
                        }}
                      >
                        <SoftTypography variant="subtitle2">
                          Expedido en San Luis a los{" "}
                          {dayjs(data?.guiaByUrl?.fechaExpedicion).format("DD")} días del mes de{" "}
                          {meses[Number(dayjs(data?.guiaByUrl?.fechaExpedicion).format("MM")) - 1]}{" "}
                          del año {dayjs(data?.guiaByUrl?.fechaExpedicion).format("YYYY")}.
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={7} />
                      <Grid
                        item
                        xs={5}
                        mt={4}
                        pb={1}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                      >
                        <img
                          src={firmaGuia}
                          alt="Firma Funcionario"
                          style={{ width: "100px", height: "auto" }}
                        />
                        <SoftTypography variant="caption" textAlign="center">
                          Carla Ocaña Leroy <br /> Jefa de Área Fauna <br /> Dirección Biodiversidad{" "}
                          <br />
                          Secretaria de Ambiente Y Desarrollo Sustentable
                        </SoftTypography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        pb={1}
                        sx={{
                          lineHeight: 1,
                        }}
                      >
                        <SoftTypography variant="caption">
                          Nota: Este documento es válido para el traslado de productos fuera de la
                          provincia de San Luis
                        </SoftTypography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        pb={1}
                        sx={{
                          lineHeight: 1,
                        }}
                      >
                        <Grid display="flex" justifyContent="center">
                          <SoftTypography variant="caption" fontWeight="bold">
                            DISPOSICIONES
                          </SoftTypography>
                        </Grid>
                        <SoftTypography
                          variant="caption"
                          sx={{
                            fontSize: 9,
                          }}
                        >
                          1° El presente documento sólo es válido a los efectos del transporte fuera
                          de los límites de esta provincia.
                          <br />
                          2° Cuando el producto y/o subproducto es transportado en vehículo
                          automotor específico, el responsable del todado debe presentar esta Guía
                          en el primer puesto policial al ingresar a la provincia de destino, a los
                          efectos de que el mismo sea inspeccionado por la Autoridad Policial y
                          proceda a dejar constancia de este acto (Certificación Policial).
                          <br /> 3° Si para el transporte del producto y/o subproducto fuera
                          utilizado el medio específico a que se hace mención en el punto SEGUNDO,
                          el destinatario del mismo debera presentar este documento dentro de los
                          cinco (5) días de su emisión ante el Organismo competente de su
                          jurisdicción, a los efectos de que este proceda a su inscripción y otorgue
                          el Certificado de Origen y Legítima Tenencia.
                          <br />
                          4° Si el producto y/o subproducto fuera transportado por un medio que no
                          fuera el citado anteriormente, sea este F.F C C. Debe observarse lo
                          siguiente. A) el remitente, una vez producido el despacho, presentará al
                          Organismo competente de su Jurisdicción el comprobante respectivo para que
                          efectúe las anotaciones del caso, y B) el destinatario, antes de proceder
                          al retiro del producto y/o subproducto del depósito de la empresa, hará
                          conocer esta situación al Organismo competente de su jurisdicción a los
                          efectos que, desde ese momento, quede sometido a las inspecciones que
                          resulten necesarias para extender el Certificado de Origen y Legítima
                          Tenencia.
                          <br />
                          5° No se admitirán fotocopias de la presente Guía, sólo es válido el
                          original.
                          <br />
                          6° Se observará toda otra norma dictada al efecto.
                        </SoftTypography>
                      </Grid>
                    </Grid>
                  </SoftBox>
                </SoftBox>
              ) : (
                <SoftBox p={2}>
                  <SoftBox display="flex" justifyContent="center" alignItems="center">
                    <SoftBox
                      component="img"
                      src={logo}
                      alt="Gobierno de San Luis Logo"
                      width="300px"
                      p={3}
                    />
                  </SoftBox>
                  <SoftBox display="flex" justifyContent="center" alignItems="center">
                    <Icon fontSize="large" color="error">
                      error
                    </Icon>
                  </SoftBox>
                  <SoftBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    p={2}
                    textAlign="center"
                  >
                    <SoftTypography variant="h6">
                      {data?.permisoOcCotoByUrl?.id ? "Permiso no válido" : "Permiso no encontrado"}
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
    </PageLayout>
  );
}

export default ControlGuia;
